import { useQuery } from '@tanstack/react-query'

import { getDataAccessRequestLabels } from 'services/data-access-requests'
import {
  DataAccessRequestQueryOptions,
  withDataAccessRequestsEnabled
} from 'services/data-access-requests/hooks/withDataAccessRequestsEnabled'
import { DataAccessRequestQueryKeys } from 'services/data-access-requests/queryKeys'
import type { GetDataAccessRequestLabelsResponse } from 'services/data-access-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetDataAccessRequestLabelsFilter = (
  options?: DataAccessRequestQueryOptions<GetDataAccessRequestLabelsResponse, ApiErrorResponse>
) => {
  const { enabled: enabledOption, ...restOptions } = options ?? {}

  return useQuery<GetDataAccessRequestLabelsResponse, ApiErrorResponse>({
    queryKey: DataAccessRequestQueryKeys.FilterLabels(),
    queryFn: ({ signal }) => getDataAccessRequestLabels({ signal }),
    enabled: withDataAccessRequestsEnabled(enabledOption ?? true),
    ...restOptions
  })
}
